"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoteIcon = void 0;
var React = require("react");
var IconWrapper_1 = require("../Icon/IconWrapper");
var NoteIcon = function (props) { return (React.createElement(IconWrapper_1.IconWrapper, __assign({}, props),
    React.createElement("path", { fill: "currentColor", d: "M17.5,9.25 L15.5,9.25 C14.5335017,9.25 13.75,8.46649831 13.75,7.5 L13.75,5.5 L7.28571429,5.5 C6.85177627,5.5 6.5,5.86376864 6.5,6.3125 L6.5,17.6875 C6.5,18.1362314 6.85177627,18.5 7.28571429,18.5 L16.7142857,18.5 C17.1482237,18.5 17.5,18.1362314 17.5,17.6875 L17.5,9.25 Z M15.25,6.4215634 L15.25,7.5 C15.25,7.63807119 15.3619288,7.75 15.5,7.75 L16.5370564,7.75 L15.25,6.4215634 Z M19,7.99249621 L19,19 C19,19.5522847 18.5522847,20 18,20 L6,20 C5.44771525,20 5,19.5522847 5,19 L5,5 C5,4.44771525 5.44771525,4 6,4 L15,4 L19,7.99249621 Z" }))); };
exports.NoteIcon = NoteIcon;
